var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineTeachingPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14119",
    "data-name": "Group 14119",
    transform: "translate(-374 -4055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14109",
    "data-name": "Group 14109",
    transform: "translate(-903 -1366)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1277 5421)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13792",
    "data-name": "Group 13792",
    transform: "translate(372 4044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M17.449,20.984A.984.984,0,0,0,16.465,20h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.734,2.5a.227.227,0,0,1-.227.227H14.007a.227.227,0,0,1-.227-.227V21.007a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M123.449,20.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.734,2.5a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227V21.007a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-101.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M17.449,141.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.734,2.5a.227.227,0,0,1-.227.227H14.007a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(0 -115.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M17.449,261.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.734,2.5a.227.227,0,0,1-.227.227H14.007a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(0 -229.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M17.449,381.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.734,2.5a.227.227,0,0,1-.227.227H14.007a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(0 -344.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M288.449,20.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.734,2.5a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227V21.007a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-258.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M394.449,20.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.78,2.5a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227V21.007a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-359.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M394.449,141.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.78,2.5a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-359.709 -115.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M394.449,381.984a.984.984,0,0,0-.984-.984h-2.48a.984.984,0,0,0-.984.984v2.48a.984.984,0,0,0,.984.984h2.48a.984.984,0,0,0,.984-.984Zm-.78,2.5a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-359.709 -344.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M128.379,144.89a1.474,1.474,0,0,0-1.1.179,1.628,1.628,0,0,0-.28-.082,1.478,1.478,0,0,0-1.125.233c-.05.034-.1.069-.142.106a1.743,1.743,0,0,0-1.1.2l-.961-1.408a1.722,1.722,0,0,0-.219-.292v-1.832a1,1,0,0,0-.99-.991h-2.473a.992.992,0,0,0-.986.991v2.473a.986.986,0,0,0,.986.985h.978a1.738,1.738,0,0,0,.225.379l1.844,2.7a2.41,2.41,0,0,0-.279.642,2.891,2.891,0,0,0,.542,2.439,4.391,4.391,0,0,0,2.816,1.892,3.714,3.714,0,0,0,2.72-.5,6.2,6.2,0,0,0,1.894-1.815,3.537,3.537,0,0,0-.1-3.77C129.638,145.671,129.246,145.091,128.379,144.89Zm-.031,7.4A3.235,3.235,0,0,1,124,151.127a2.037,2.037,0,0,1-.408-1.78l.745,1.09a.427.427,0,0,0,.705-.483l-3.157-4.62c-.022-.03-.57-.752.006-1.145.337-.231.6-.279,1.069.41l1.582,2.313a.819.819,0,0,1,.363-.557.94.94,0,0,1,.722-.179.925.925,0,0,1,.372.167.906.906,0,0,1,.356-.417.62.62,0,0,1,.478-.1,1.182,1.182,0,0,1,.567.337.653.653,0,0,1,.255-.321.646.646,0,0,1,.53-.118c.464.108.7.363,1.7,2.114C131.274,150.292,129.3,151.644,128.348,152.294Z",
    transform: "translate(-101.138 -115.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M287.647,389.426a.221.221,0,0,1,.023.116v2.468a.2.2,0,0,1-.221.193h-2.468a.181.181,0,0,1-.2-.193v-1.182c-.183.016-.331.025-.492.025-.092,0-.2,0-.287-.009v1.166a.973.973,0,0,0,.98.973h2.468a.99.99,0,0,0,1-.973v-2.468a1,1,0,0,0-.247-.646,6.411,6.411,0,0,1-.555.53Z",
    transform: "translate(-258.572 -351.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M122.685,381.039a.987.987,0,0,0-.227-.039H119.99a1.011,1.011,0,0,0-.99,1.008v2.468a.981.981,0,0,0,.99.973h2.468a.982.982,0,0,0,.991-.973v-2.468c0-.025-.005-.056-.007-.081A5.648,5.648,0,0,1,122.685,381.039Zm.03,3.449a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-101.138 -344.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M119.99,265.449h2.122a3.409,3.409,0,0,1-.176-.78H119.99a.205.205,0,0,1-.21-.214v-2.468a.2.2,0,0,1,.21-.207h1.263l-.517-.78h-.746a.993.993,0,0,0-.99.987v2.468A1,1,0,0,0,119.99,265.449Z",
    transform: "translate(-101.138 -229.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M287.448,144.623h-.409a5.855,5.855,0,0,1,.669.742.97.97,0,0,0,.74-.931v-2.468a.984.984,0,0,0-1-.966H284.98a.967.967,0,0,0-.98.966v2.24c.046,0,.1-.005.144-.005a2.266,2.266,0,0,1,.433.042c.023,0,.059.009.082.015a1.089,1.089,0,0,1,.121-.041v-2.251a.176.176,0,0,1,.2-.187h2.468c.123,0,.221.064.221.187v2.468C287.669,144.557,287.571,144.623,287.448,144.623Z",
    transform: "translate(-258.571 -115.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M393.417,261h-2.468a.987.987,0,0,0-.967.806,4.661,4.661,0,0,1,.539,2.362,4.041,4.041,0,0,1-.2,1.051.984.984,0,0,0,.626.23h2.468a1.02,1.02,0,0,0,1.015-.994v-2.468A1.014,1.014,0,0,0,393.417,261Zm.235,3.488a.227.227,0,0,1-.227.227h-2.481a.227.227,0,0,1-.227-.227v-2.481a.227.227,0,0,1,.227-.227h2.481a.227.227,0,0,1,.227.227Z",
    transform: "translate(-359.692 -229.947)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineTeachingPlatform);
export default __webpack_public_path__ + "static/media/online-teaching-platform.4906c919ec754a962479e6f3f6e93393.svg";
export { ForwardRef as ReactComponent };